<template>
    <div
        v-smooth-height="finalHeight"
        class="m-blog-wrapper"
        :style="{ transition: 'all ' + smoothHeight.duration + 's' }"
    >
        <div ref="postsList">
            <transition-group
                :key="categoryUrlEncode"
                name="list"
                tag="ul"
                class="m-blog-wrapper__posts"
            >
                <router-link
                    v-for="post in postsToShow"
                    :key="post.id"
                    class="blog-post-router"
                    :style="{ transition: 'all ' + smoothHeight.duration + 's' }"
                    :to="{name: 'blog-single', params: {slug: post.slug}}"
                >
                    <y-blog-card :post-data="post" />
                </router-link>
            </transition-group>
            <div class="m-blog-wrapper__more">
                <button
                    v-if="showMoreBtn || loadingMoreBtn"
                    class="blog-more-btn"
                    :disabled="$wait.is(`loading-posts-blog-${categoryUrlEncode}`)"
                    @click="$emit('fetchPosts')"
                >
                    <y-loading
                        v-if="loadingMoreBtn"
                        :active="loadingMoreBtn"
                        height="100%"
                        position="relative"
                    />
                    <span v-else>
                        {{ $t('blog.button.see_more') }}
                    </span>
                </button>
                <span v-else-if="!postsToShow.length">
                    {{ $t('blog.no_posts') }}
                </span>
            </div>
        </div>
    </div>
</template>

<script >
    import YBlogCard from '@modules/blog/components/Categories/BlogCard/BlogCard.vue';

    export default {
        name      : 'BlogWrapper',
        components: { YBlogCard },

        /**
         *
         * @inheritDoc
         */
        directives: {
            /**
             * @inheritDoc
             */
            smoothHeight: {
                /**
                 * @inheritDoc
                 */
                inserted(el, binding) {
                    // eslint-disable-next-line no-param-reassign
                    el.style.height = `${400}px`;
                    // eslint-disable-next-line no-param-reassign
                    el.style.transition = `all ${binding.value.duration}s ease-in-out`;
                },

                /**
                 * @inheritDoc
                 */
                update(el, binding) {
                    // eslint-disable-next-line no-param-reassign
                    el.style.height = `${binding.value || 400}px`;
                },

            },
        },

        props: {
            categoryUrlEncode: {
                type   : String,
                default: 'latest',
            },
            postsToShow: {
                type: Array,
            },
            showMoreBtn: {
                type: Boolean,
            },
            loadingMoreBtn: {
                type: Boolean,
            },
        },

        /**
         *
         * @inheritDoc
         */
        data() {
            return {
                smoothHeight: {
                    duration : 0.7,
                    rowNumber: 0,
                },
                finalHeight: 0,

            };
        },

        computed: {

            /**
             * Return number of posts in each row base on device width
             *
             * @returns {number}
             */
            postsPerRow() {
                // eslint-disable-next-line no-nested-ternary
                return this.$mq === 'xlg' ? 3
                    : this.$mq === 'lg' ? 2
                        : 1;
            },
        },

        watch: {
            postsPerRow: {
                /**
                 * change number of row numbers base on width of device
                 *
                 * @inheritDoc
                 */
                handler() {
                    this.heightOfList();
                },

            },

            postsToShow: {
                /**
                 * Change number of posts
                 * then change in the height of list
                 *
                 * @inheritDoc
                 */
                handler() {
                    this.heightOfList();
                },

            },

        },

        /**
         *
         * @inheritDoc
         */
        mounted() {
            this.heightOfList();
        },

        /**
         *
         * @inheritDoc
         */
        methods: {

            /**
             * height
             *
             * @inheritDoc
             */
            heightOfList() {
                if (!this.$refs.postsList) {
                    return;
                }
                this.$nextTick(() => {
                    this.finalHeight = this.$refs.postsList.clientHeight;
                });
            },
        },
    };

</script>

<style lang="scss" src="./blog-wrapper.scss"/>
